import type { StepCount, TourFrame, TourStep } from '@carboncopyco/types';

export const calculateStepCount = (
  currentStep: TourStep,
  frames: TourFrame[]
): StepCount => {
  if (!frames?.length || !currentStep) {
    return {
      current: 0,
      total: 0,
    };
  }

  const activeSteps: TourStep[] = frames.reduce(
    (acc: TourStep[], frame: TourFrame) => {
      if (frame.isActive && !frame.isDisabled) {
        return [...acc, ...frame.steps];
      }
      return acc;
    },
    []
  );

  const currentStepIndex = activeSteps.findIndex(
    (step) => step.stepId === currentStep.stepId
  );

  return {
    current: currentStepIndex + 1,
    total: activeSteps.length,
  };
};
